module.exports = __webpack_public_path__ + "img/new-logo.13ed73e8.svg";